import React from 'react';
import { connect } from 'react-redux';
import GoBackButton from '../elements/GoBackButton';
import { __ } from 'i18n-for-browser';
import GameMaterials from '../elements/GameMaterials';

import apiCall from "../apiCall";
import PopupTitle from "../elements/PopupTitle";
import {getPopupDeviceDifficulty} from "../../helpers/popupHelper";

class Prepare extends React.Component {
  static defaultProps = {
    desktop: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      generalMaterial: [],
      vimeoId: null,
    };
    this.category = this.props.match.params.startup || 'preparation';
    this.deviceAndDifficulty = getPopupDeviceDifficulty(this.props.gameState.DefaultDifficultyId);
  }

  componentWillMount() {
    this.fetchMaterials();
    document.body.classList.add('schoolPage');
  }

  fetchMaterials() {
    const { schoolClass, project } = this.props;
    apiCall(`/generalMaterial/${schoolClass.LanguageId}/${project.DefaultDifficultyId}/${this.category}`, null, 'GET')
      .then((material) => {
        this.setState({ generalMaterial: material});
      });
  }

  renderTitle = () => {
    switch(this.props.match.params.startup) {
      case 'fairaway':
        return <PopupTitle popupId={`${this.deviceAndDifficulty}bvtfairaway`} tag={'h3'}/>;
      case 'startup':
        return <PopupTitle popupId={`${this.deviceAndDifficulty}bvtopstart`} tag={'h3'}/>;
      default:
        return <PopupTitle popupId={`${this.deviceAndDifficulty}bvtvoorbereiding`} tag={'h3'}/>;
    }
  };

  renderParagraph = () => {
    switch(this.props.match.params.startup) {
      case 'fairaway':
        return null;
      case 'startup':
        return <p>{__('sim_opstart_project_ondertitel')}</p>;
      default:
        return <p>{this.props.schoolcontact ? __('sim_docent') : __('sim_begeleider')}</p>;
    }
  };

  render() {
    const {desktop } = this.props;
    const { generalMaterial } = this.state;
    return (
      <div className={'classleader-prepare ' + (desktop ? 'portal-home darkBckg desktop-single' : '')}>
        <div className={'container general-materials-container'}>
          <div className={'title-block'}>
            <GoBackButton history={this.props.history} />
            {this.renderTitle()}
            {this.renderParagraph()}
          </div>
          <GameMaterials items={generalMaterial} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({ schoolClass: state.schoolClass, project: state.project, gameState: state.gameState }))(Prepare);



// WEBPACK FOOTER //
// ./src/components/routes/Prepare.js